module.exports = __webpack_public_path__ + "img/Zain-Jordan-Ar.c94e366c.jpg";